import { render } from "./LlmChatWidget.vue?vue&type=template&id=23152440&scoped=true"
import script from "./LlmChatWidget.vue?vue&type=script&lang=js"
export * from "./LlmChatWidget.vue?vue&type=script&lang=js"

import "./LlmChatWidget.vue?vue&type=style&index=0&id=23152440&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23152440"]])

export default __exports__